import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "previewImage", "dropZone", "existingPreview", "removalFlag", "loading"]

  static values = {
    maxSize: { type: Number, default: 5242880 }, // 5MB
    msgFileTooLarge: { type: String, default: "파일 크기는 5MB 이하여야 합니다." },
    msgNotImage: { type: String, default: "이미지 파일만 업로드 가능합니다." }
  }

  triggerInput() {
    if (this.hasInputTarget) {
      this.inputTarget.click()
    }
  }

  dragOver(e) {
    e.preventDefault()
    if (this.hasDropZoneTarget) {
      this.dropZoneTarget.style.borderColor = "#4F46E5"
      this.dropZoneTarget.style.background = "#EEF2FF"
    }
  }

  dragLeave(e) {
    e.preventDefault()
    if (this.hasDropZoneTarget) {
      this.dropZoneTarget.style.borderColor = "#E5E7EB"
      this.dropZoneTarget.style.background = "#F9FAFB"
    }
  }

  drop(e) {
    e.preventDefault()
    if (this.hasDropZoneTarget) {
      this.dropZoneTarget.style.borderColor = "#E5E7EB"
      this.dropZoneTarget.style.background = "#F9FAFB"
    }

    const files = e.dataTransfer.files
    if (files.length > 0) {
      this.handleFile(files[0])
    }
  }

  onChange() {
    if (this.hasInputTarget && this.inputTarget.files.length > 0) {
      this.handleFile(this.inputTarget.files[0])
    }
  }

  handleFile(file) {
    if (file.size > this.maxSizeValue) {
      alert(this.msgFileTooLargeValue)
      return
    }

    if (!file.type.startsWith("image/")) {
      alert(this.msgNotImageValue)
      return
    }

    // Show loading state
    this.showLoading()

    // Simulate loading delay for UX
    setTimeout(() => {
      this.showPreview(file)
      this.hideLoading()
    }, 500)
  }

  showLoading() {
    if (this.hasDropZoneTarget) {
      this.dropZoneTarget.style.display = 'none'
    }
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.add('show')
    }
  }

  hideLoading() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove('show')
    }
  }

  showPreview(file) {
    const reader = new FileReader()
    reader.onload = (e) => {
      if (this.hasPreviewImageTarget) {
        this.previewImageTarget.src = e.target.result
      }
      if (this.hasPreviewTarget) {
        this.previewTarget.style.display = "block"
      }
      if (this.hasExistingPreviewTarget) {
        this.existingPreviewTarget.style.display = "none"
      }
    }
    reader.readAsDataURL(file)
  }

  remove() {
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
    }
    if (this.hasPreviewTarget) {
      this.previewTarget.style.display = "none"
    }
    if (this.hasPreviewImageTarget) {
      this.previewImageTarget.src = ""
    }
    if (this.hasDropZoneTarget) {
      this.dropZoneTarget.style.display = 'block'
    }
  }

  removeExisting() {
    if (this.hasExistingPreviewTarget) {
      this.existingPreviewTarget.style.display = "none"
    }
    if (this.hasRemovalFlagTarget) {
      this.removalFlagTarget.value = "true"
    }
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
    }
    if (this.hasDropZoneTarget) {
      this.dropZoneTarget.style.display = 'block'
    }
  }
}
